/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

import pluginFactory from 'taoTests/runner/plugin';

/**
 * This plugin is intentionally left empty.
 * It is loaded in place of any specified plugin that cannot be resolved, to prevent an error.
 */
export default pluginFactory({
    name: 'dummy',

    init() {}
});
